"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const vehicle_1 = require("./vehicle");
let VehicleOnlineCheck = class VehicleOnlineCheck {
    constructor(vehicleModel) {
        this.vehicleModel = vehicleModel;
        this.onlineCheck = null;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.check) {
                this.onlineCheck = this.check;
                return;
            }
            const checkResult = yield this.vehicleModel.onlineCheck(this.vehicleId, false);
            this.onlineCheck = checkResult;
        });
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], VehicleOnlineCheck.prototype, "vehicleId", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], VehicleOnlineCheck.prototype, "check", void 0);
VehicleOnlineCheck = __decorate([
    (0, core_1.Component)({
        selector: 'vehicle-online-check',
        template: /* html */ `
    <div class="boxL" *ngIf="onlineCheck">
      <div class="cards-wrap">
      <ab-card
        *ngIf="onlineCheck.error"
        classes="filled warning"
        titleIcon="shield-exclamation"
        title="Fahrzeugdaten sind unvollständig"
        mainText="Das Fahrzeug ist nicht bereit, um es online oder für Kunden zu bewerben. Ergänze folgende Daten, bevor du mit der Aktion fortfahren kannst."
        [mainSubtitle]="onlineCheck.errorCodes.join('<br>')"
      ></ab-card>
      </div>
    </div>
  `,
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof vehicle_1.Vehicle !== "undefined" && vehicle_1.Vehicle) === "function" ? _a : Object])
], VehicleOnlineCheck);
exports.default = VehicleOnlineCheck;
